import { useForm } from '@formily/react';
import { evalStatement, Scope } from '@micun/form-expression';
import { ScopeContext } from '@micun/form-expression/react/index';
import qs from 'qs';
import { useContext } from 'react';
import { useMessage } from "./useMessage";
import { useFieldMap } from "./useReactions";
export var useAction = function useAction() {
  var _useContext = useContext(ScopeContext),
    scope = _useContext.scope;
  var form = useForm();
  var getFieldMap = useFieldMap();
  var message = useMessage();
  var processAction = function processAction(action) {
    var type = action.type,
      nextAction = action.nextAction;
    var fieldMap = getFieldMap();
    switch (type) {
      case 'submit':
      case 'stash':
      case 'back':
        message.warning("PC \u7AEF\u6682\u4E0D\u652F\u6301\u5F53\u524D\u52A8\u4F5C(".concat(type, ")"));
        break;
      case 'reset':
        {
          var source = action.form;
          var currentForm = form;
          if (source) {
            currentForm = form.query(source).take();
          }
          if (!currentForm) {
            console.error('button 没有找到 form 字段');
            return;
          }
          console.log('reset');
          currentForm.reset().finally(function () {
            if (nextAction) {
              processAction(nextAction);
            }
          });
        }
        break;
      case 'edit':
        {
          var _source = action.form;
          var _currentForm = form;
          if (_source) {
            _currentForm = form.query(_source).take();
          }
          if (!_currentForm) {
            console.error('button 没有找到 form 字段');
            return;
          }
          _currentForm.readOnly = false;
          console.log('edit');
          if (nextAction) {
            processAction(nextAction);
          }
        }
        break;
      case 'statement':
        {
          var statements = action.statements,
            _action$recursion = action.recursion,
            recursion = _action$recursion === void 0 ? false : _action$recursion,
            _action$mode = action.mode,
            mode = _action$mode === void 0 ? 'field' : _action$mode;
          if (statements) {
            var context = mode === 'field' ? fieldMap : form.values;
            var newScope = new Scope({
              context: {
                form: form
              },
              parent: scope
            });
            evalStatement(Array.isArray(statements) ? statements : [statements], {
              context: context,
              recursion: recursion,
              parentScope: newScope
            });
          } else {
            console.error('no statements');
          }
          if (nextAction) {
            processAction(nextAction);
          }
        }
        break;
      case 'open':
        {
          var _action$navigation = action.navigation,
            navigation = _action$navigation === void 0 ? 'navigateTo' : _action$navigation,
            url = action.url,
            params = action.params,
            _action$recursion2 = action.recursion,
            _recursion = _action$recursion2 === void 0 ? false : _action$recursion2,
            _action$mode2 = action.mode,
            _mode = _action$mode2 === void 0 ? 'field' : _action$mode2;
          var query = '';
          if (params) {
            var _context = _mode === 'field' ? fieldMap : form.values;
            var _newScope = new Scope({
              context: {
                form: form
              },
              parent: scope
            });
            query = qs.stringify(evalStatement([params], {
              context: _context,
              parentScope: _newScope,
              recursion: _recursion
            }));
          }
          console.log('open', navigation, url, query);
          window.open("".concat(url, "?").concat(query), '_blank');
          if (nextAction) {
            processAction(nextAction);
          }
        }
        break;
    }
  };
  return processAction;
};